import { UtilitarioService } from '@app/services/utilitario.service';

export class Filtros {

    ParticipanteId: number;
    TipoData: string;
    DataInicial: string;
    DataFinal: string;
    UnidadeId: number;
    Observacao: string;
    ProcessoId: number;
    TipoDRId: number;
    TipoDeAcaoId: number;


    constructor() {
        const hoje = new Date().toISOString().split('T')[0];
        this.DataInicial = hoje;
        this.DataFinal = hoje;
    }

}
